import { Component, OnInit, Input, ViewChild, Inject, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DatastoreService } from '../../services';
import { CommonFunctionsService } from '../../services';
import { Accordion, createAll } from 'govuk-frontend';

@Component({
  selector: 'app-custom-object-accordion',
  templateUrl: './custom-object-accordion.component.html',
  styleUrls: ['./custom-object-accordion.component.scss']
})
export class CustomObjectAccordionComponent implements OnInit {

  @Input() page:string;
  @ViewChild('accordion') accordion: any;

  customObjects: any[] = [];

  constructor(@Inject(DOCUMENT) private document: Document, private readonly dataStore: DatastoreService, private commonFunctionsService: CommonFunctionsService, private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.setup();
  }

  async setup() {
    const booking = this.dataStore.booking;
    await this.commonFunctionsService.setupCustomObjects(booking);
    if (this.dataStore.customObjects) {
      if (this.dataStore.customObjects[this.page]) {
        for (const obj of this.dataStore.customObjects[this.page]) {
          if (obj.component === 'accordion') {
            this.customObjects.push(obj);
          }
        }
      }
    }
    try {
      this.changeDetectorRef.detectChanges();
      // remove ng star inserted...
      new Accordion(this.accordion.nativeElement, {});
    }
    catch (err) {
      console.log(err);
    }

  }

}
